import { MessageIdsAtom, MessageType } from "../atoms";
import { useSetRecoilState } from "recoil";

export const useAddMessage = () => {
    const setMessages = useSetRecoilState(MessageIdsAtom);

    const addMessage = (message: MessageType | MessageType[]) => {
        setMessages((prev) =>
            Array.isArray(message) ? [...prev, ...message] : [...prev, message]
        );
    };

    return { addMessage };
};
